import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { getCategoryDetails } from "../server/api";

const ServicesDetail = () => {
  const { title } = useParams();
  const decodedTitle = decodeURIComponent(title);

  const [serviceDetail, setServiceDetail] = useState(null);

  useEffect(() => {
    const fetchService = async () => {
      try {
        const res = await getCategoryDetails(decodedTitle); // API me backend filter by title
        if (res.status === true) {
          setServiceDetail(res.data);
        }
      } catch (err) {
        console.error("Service Detail API Error:", err);
      }
    };
    fetchService();
  }, [decodedTitle]);

  if (!serviceDetail) return <p>Loading...</p>;

  return (
    <div className="container py-5">
      <h1>{serviceDetail.title}</h1>
      {serviceDetail.image && (
        <img
          src={`http://localhost:5000/${serviceDetail.image}`}
          alt={serviceDetail.title}
          className="img-fluid mb-3"
        />
      )}
      <p>{serviceDetail.description}</p>
    </div>
  );
};

export default ServicesDetail;
